import React, { useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdRevenuePerGame() {
  // Using only Daily data since tabs/period switcher removed
  const data = [
    { game: "Mario", earnings: 20 },
    { game: "Sonic", earnings: 15 },
    { game: "Pac-Man", earnings: 10 },
  ];

  const [selectedGame, setSelectedGame] = useState("");

  const handleFilterChange = (e) => {
    setSelectedGame(e.target.value);
  };

  const handleReset = () => {
    setSelectedGame("");
  };

  const filteredData = selectedGame
    ? data.filter(
        (item) => item.game.toLowerCase() === selectedGame.toLowerCase()
      )
    : data;

  const chartData = {
    labels: filteredData.map((item) => item.game),
    datasets: [
      {
        label: "Earnings ($)",
        data: filteredData.map((item) => item.earnings),
        backgroundColor: "rgba(255, 159, 64, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff",
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff",
        },
      },
    },
  };

  return (
    <DashboardLayout>
      {/* Filter Card Without Tabs */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Game</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedGame}
                onChange={handleFilterChange}
              >
                <option value="">All games</option>
                <option value="mario">Mario</option>
                <option value="sonic">Sonic</option>
                <option value="pac-man">Pac-Man</option>
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button className="btn btn-success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Ad Revenue per Game</h5>
          <p className="card-text">
            Breakdown of earnings by game.
          </p>
          <div className="table-responsive">
            <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>Game Name</th>
                  <th>Earnings ($)</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.game}</td>
                    <td>${item.earnings.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Earnings Chart</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AdRevenuePerGame;
